var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1024.000000pt",
    height: "1024.000000pt",
    viewBox: "0 0 1024.000000 1024.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1024.000000) scale(0.100000,-0.100000)",
    fill: "inherit",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4715 10225 c-140 -27 -269 -86 -380 -176 -106 -85 -4149 -4139 -4187 -4199 -191 -298 -197 -628 -17 -938 25 -43 397 -421 1504 -1530 1600 -1603 1548 -1555 1727 -1620 111 -40 180 -52 300 -52 175 0 328 46 471 140 100 67 4206 4174 4265 4268 54 84 97 190 117 287 14 72 15 237 13 1610 -4 1730 5 1562 -88 1750 -108 218 -285 367 -525 442 l-90 28 -1520 2 c-1231 1 -1533 -1 -1590 -12z m2919 -841 l46 -7 0 -1401 0 -1401 -2008 -2008 -2007 -2007 -1405 1405 -1405 1405 2010 2010 2010 2010 1356 0 c746 0 1377 -3 1403 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6270 8512 c-73 -24 -125 -59 -183 -121 -155 -166 -149 -420 14 -584 246 -246 659 -111 719 234 24 136 -26 275 -134 377 -84 78 -148 104 -271 109 -68 2 -104 -1 -145 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5042 8099 c-23 -4 -70 -20 -105 -35 -58 -26 -130 -95 -1156 -1118 -601 -600 -1113 -1117 -1136 -1149 -61 -81 -80 -142 -80 -257 0 -86 3 -101 32 -163 119 -251 424 -334 640 -174 26 20 541 530 1144 1134 1027 1029 1097 1102 1123 1160 57 132 56 243 -3 369 -55 118 -175 208 -310 234 -61 11 -88 11 -149 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5845 7232 c-28 -10 -70 -29 -95 -44 -26 -15 -512 -495 -1156 -1140 -1216 -1218 -1149 -1144 -1175 -1292 -21 -124 20 -254 112 -351 95 -100 196 -141 333 -133 117 7 178 34 278 122 46 41 554 546 1129 1122 1124 1128 1088 1088 1119 1223 16 68 8 170 -19 240 -43 115 -157 221 -275 256 -67 20 -189 19 -251 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9253 8512 c-247 -88 -362 -367 -246 -596 65 -128 227 -235 356 -236 l27 0 0 -1402 0 -1403 -1922 -1922 -1923 -1923 -305 304 c-333 331 -349 343 -484 367 -79 13 -160 2 -244 -36 -61 -28 -151 -110 -186 -169 -74 -126 -74 -306 0 -431 36 -62 687 -706 762 -753 225 -144 524 -174 770 -75 174 69 56 -44 2175 2073 1083 1081 1990 1992 2017 2025 95 119 159 266 180 413 8 54 10 524 8 1577 l-3 1500 -28 90 c-75 241 -225 419 -442 526 -131 64 -195 80 -340 85 -99 4 -129 1 -172 -14z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/Tags.d0efb127f28fe6cd9c2b07109a1223c3.svg";
export { ForwardRef as ReactComponent };